// Formats Shopify cents (integer) to a locale price string, e.g. 3599 → "35,99 CHF"
// subscribe / publish / PUB_SUB_EVENTS are global — loaded via pubsub.js + constants.js in theme.liquid
// window.currency is set in snippets/locales-variables.liquid from cart.currency.symbol
function _formatPrice(cents) {
  const symbol = window.currency || ' €';
  return (cents / 100).toFixed(2).replace('.', ',') + symbol;
}

// Matches product-variant-base-price.liquid: price / weight * 10, rounded to 2 decimals
function _calcBasePricePerKg(unitPriceCents, weight) {
  if (!weight || weight <= 0 || !unitPriceCents) return 0;
  return Math.round((unitPriceCents / weight) * 10 * 100) / 100;
}
